import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { growthSdk } from '@fff-web/growth-sdk';
import GlobalNavInternalContext from '../context/GlobalNavInternalContext';

export type SubscriptionStatus = 'EXPIRED' | 'ACTIVE' | 'CANCELED';

export const useClubMemberSubscription = () => {
  const { env } = useContext(GlobalNavInternalContext);

  const growthSdkInstance = useMemo(() => {
    return growthSdk(env.REACT_APP_ENVIRONMENT as Parameters<typeof growthSdk>[0], true);
  }, [env.REACT_APP_ENVIRONMENT]);

  const [status, setStatus] = useState<SubscriptionStatus | null>(null);
  const [isNonRenew, setIsNonRenew] = useState<boolean>(false);
  const [id, setId] = useState<string | null>(null);
  const [nextRenewalDate, setNextRenewalDate] = useState<string>('');
  const [startAt, setStartAt] = useState<string>('');

  const fetchClubMemberSubscription = useCallback(async () => {
    const response = await growthSdkInstance.getUserSubscriptions();

    if (!response.ok) return;

    const membershipSub = response.data.subscriptions.find((sub) => sub.type === 'MEMBERSHIP');

    if (!membershipSub) return;

    setId(membershipSub.id);
    setStatus(membershipSub.status === 'NON_RENEWING' ? 'CANCELED' : membershipSub.status);
    setIsNonRenew(membershipSub.nonrenew);
    setNextRenewalDate(membershipSub.nextBillDate);
    setStartAt(membershipSub.startAt);
  }, [growthSdkInstance]);

  useEffect(() => {
    fetchClubMemberSubscription();
  }, [fetchClubMemberSubscription]);

  return {
    status,
    id,
    isNonRenew,
    nextRenewalDate,
    startAt,
    refetch: fetchClubMemberSubscription,
  };
};
